<script setup>
// The steps are numbered because order is the point: nobody quotes before the
// window is measured, and the person who measures it is the customer.
import { steps } from '@/data/catalog'
import WhatsappButton from '@/components/WhatsappButton.vue'
import QuoteButton from '@/components/QuoteButton.vue'

defineProps({
  phone: { type: String, required: true }
})
</script>

<template>
  <section id="proceso" class="bg-sand text-ink scroll-mt-16">
    <div class="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <header class="max-w-2xl">
        <p class="eyebrow text-glow-ink">Cómo trabajamos</p>
        <h2 class="display mt-4 text-balance text-[clamp(1.9rem,4vw,3rem)]">
          De tu medida a la cortina instalada
        </h2>
      </header>

      <ol class="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-3 lg:mt-12">
        <li
          v-for="(step, i) in steps"
          :key="step.title"
          class="border-t border-ink/20 pt-5"
        >
          <span class="display block text-2xl text-glow-ink tabular-nums">
            {{ String(i + 1).padStart(2, '0') }}
          </span>
          <h3 class="display mt-1.5 text-2xl">{{ step.title }}</h3>
          <p class="mt-2 leading-relaxed text-ink/75">{{ step.note }}</p>
          <a
            v-if="step.href"
            :href="step.href"
            class="-my-1 mt-1 inline-flex items-center gap-1.5 py-3 font-semibold text-glow-ink underline decoration-glow-ink/30 underline-offset-4 transition-colors hover:decoration-glow-ink"
          >
            {{ step.hrefLabel }}
            <span aria-hidden="true">↓</span>
          </a>
        </li>
      </ol>

      <!-- Los dos canales con la frase que hace la misma promesa: el formulario
           relleno y WhatsApp en contorno, para no empujar solo al chat. -->
      <div class="mt-12 flex flex-wrap items-center gap-x-4 gap-y-4">
        <QuoteButton label="Pedir cotización" source="process" variant="ink" />
        <WhatsappButton
          :phone="phone"
          variant="outline"
          subject="una cotización con las medidas de mi ventana"
          label="WhatsApp"
          source="process"
        />
        <p class="w-full text-ink/75 sm:ml-2 sm:w-auto">La cotización no tiene costo.</p>
      </div>
    </div>
  </section>
</template>
